import React from 'react';
import { Story } from '../components/Story';
import { Quality } from '../components/Quality';
import { Certifications } from '../components/Certifications';

export default function AboutPage() {
  return (
    <>
      <Story />
      <Quality />
      <Certifications />
    </>
  );
}
